import PropTypes from 'prop-types'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CheckCircle from "@mui/icons-material/CheckCircle"
import { iconMap } from './iconImports'
import {
    TEMPLATE_STYLES,
  } from "@/constants/onboarding";
import { useContext } from 'react'
import { OnboardingContext } from '@/context/OnboardingContext'
import { useIconStates } from '../../../../hooks/useIconStates'

// Reusable Layout Item Component
const LayoutItem = ({ index, style, onSelect, layout }) => {
  const {
    currentIconSrc,
    setIsHovered
  } = useIconStates(style, index)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

	const { Icon, state, isActive } = currentIconSrc || {}

  return (
    <Box
      className='!m-0 overflow-hidden relative'
      sx={{
        padding: '0',
        border: '2px solid transparent',
        aspectRatio: '5/3',
        flex: '0 0 calc(50% - 7.5px)',
        cursor: 'pointer',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          transform: 'scale(1)'
        }
      }}
      onClick={() => onSelect(index)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
			{
				(Icon && typeof Icon === 'function') && <Icon state={state} isActive={isActive} />
			}
			{layout === index && (
          <Box
            className="absolute top-2 right-2 bg-white rounded-full "
            sx={{ lineHeight: 0, zIndex: 2 }}
          >
            <CheckCircle color="#FFFFFF" withBorder />
          </Box>
      
			)}
    </Box>
  )
}

LayoutItem.propTypes = {
  index: PropTypes.number.isRequired,
  style: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  layout: PropTypes.number.isRequired
}

const Layout = () => {
  const { setLayout, layout, templateStyle } = useContext(OnboardingContext)

  // Map template styles to their display names
  const styleMap = {
    [TEMPLATE_STYLES.MODERN]: 'modern',
    [TEMPLATE_STYLES.CLASSIC]: 'classic',
    [TEMPLATE_STYLES.BOLD]: 'bold',
    [TEMPLATE_STYLES.PLAYFUL]: 'playful',
    [TEMPLATE_STYLES.PROFESSIONAL]: 'professional'
  }
  const currentStyle = styleMap[templateStyle] || 'playful'
  const layoutIndices = Object.keys(iconMap[currentStyle])
  return (
    <>
      <Typography
        variant='h6'
        sx={{
          color: '#1A1A1A',
          fontWeight: 600,
          mb: '-6px',
        }}
      >
        Select a layout
      </Typography>
      <Box
        className='flex'
        sx={{
          flexWrap: 'wrap',
          columnGap: '6px',
          rowGap: '0px',
          mb: '-12px'
        }}
      >
        {layoutIndices.map((index) => (
					<>
						<LayoutItem
							key={index}
							index={parseInt(index)}
							style={currentStyle}
							onSelect={setLayout}
							layout={layout}
						/>
					</>
        ))}
      </Box>
    </>
  )
}

export default Layout
